import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useApp } from "@/context/AppContext";

export const NumberRack = ({ blocks, selected, onSelect, onDragStart, onDragEnd }) => {
  const { t } = useApp();

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-2 px-1">
        <span className="text-xs font-black uppercase tracking-[0.2em] text-ink/60 font-display">
          {t("blocks_tray")}
        </span>
        <span data-testid="rack-count" className="text-xs font-bold text-ink/50 font-mono">
          {blocks.length}
        </span>
      </div>

      <div
        data-testid="number-rack"
        className="flex flex-row flex-nowrap md:flex-wrap gap-2.5 p-3 bg-white border-2 border-ink rounded-xl shadow-brutal overflow-x-auto md:overflow-visible no-scrollbar min-h-[68px] items-center"
      >
        <AnimatePresence mode="popLayout">
          {blocks.length === 0 && (
            <motion.span
              key="empty"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-sm font-bold text-ink/50 px-2 py-3"
            >
              {t("all_placed_tray")}
            </motion.span>
          )}
          {blocks.map((b) => {
            const isSel = selected === b.id;
            return (
              <motion.button
                key={b.id}
                layout
                type="button"
                data-testid={`number-block-${b.id}`}
                draggable
                onDragStart={(e) => {
                  if (e.dataTransfer) e.dataTransfer.effectAllowed = "move";
                  onDragStart(b.id);
                }}
                onDragEnd={onDragEnd}
                onClick={() => onSelect(b.id)}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.7 }}
                whileHover={{ y: -3 }}
                whileTap={{ scale: 0.96 }}
                className={`shrink-0 relative flex items-center justify-center rounded-lg border-2 border-ink px-3.5 py-2.5 font-mono font-extrabold text-lg md:text-xl tracking-wider cursor-grab active:cursor-grabbing transition-colors ${
                  isSel
                    ? "bg-sunny shadow-brutal -translate-y-0.5"
                    : "bg-white shadow-brutal-sm hover:shadow-brutal"
                }`}
              >
                {b.value}
                <span className="absolute -top-2 -right-2 grid place-items-center w-5 h-5 rounded-full bg-ink text-cream text-[10px] font-black font-display">
                  {b.length}
                </span>
              </motion.button>
            );
          })}
        </AnimatePresence>
      </div>
    </div>
  );
};
